import Dashboard from './dashboard/portfolio';
import Home from '../income-history/incomeHistoryHome';
import Transaction from '../income-history/asset-transaction';
import Portfolio from '../portfolio';
import AlternativesPositions from '../portfolio/alternatives/alternatives-positions';
import AlternativesTransactions from '../portfolio/alternatives/alternatives-transactions';
import CashPositions from '../portfolio/cash/cash-positions';
import CashTransactions from '../portfolio/cash/cash-transactions';
import BondsPositions from '../portfolio/bonds/bonds-positions';
import BondsTransactions from '../portfolio/bonds/bonds-transactions';
import EquitiesPositions from '../portfolio/equities/equities-positions';
import EquitiesTransactions from '../portfolio/equities/equities-transactions';
import OptionsDerivativesPositions from '../portfolio/options-derivatives/options-derivatives-positions';
import OptionsDerivativesTransactions from '../portfolio/options-derivatives/options-derivatives-transactions';
import MMInstrumentsPositions from '../portfolio/mm-instruments/mm-instruments-positions';
import MMInstrumentsFundsTransactions from '../portfolio/mm-instruments/mm-instruments-funds-transactions';
import MMInstrumentsDepositsTransaction from '../portfolio/mm-instruments/mm-instruments-deposits-transaction';
import FxForwardsPositions from '../portfolio/fx-forwards/fx-forwards-positions';
import FxForwardsTransactions from '../portfolio/fx-forwards/fx-forwards-transactions';
import LoansPositions from '../portfolio/loans/loans-positions';
import LoansTransactions from '../portfolio/loans/loans-transactions';
import VariousPositions from '../portfolio/various/various-positions';
import VariousTransactions from '../portfolio/various/various-transactions';
import TransactionAdvice from '../portfolio/transactions/transaction-details/transaction-advice';

export default {
  Dashboard,
  Home,
  Transaction,
  AlternativesPositions,
  AlternativesTransactions,
  CashPositions,
  CashTransactions,
  BondsPositions,
  BondsTransactions,
  EquitiesPositions,
  EquitiesTransactions,
  OptionsDerivativesPositions,
  OptionsDerivativesTransactions,
  MMInstrumentsPositions,
  MMInstrumentsFundsTransactions,
  MMInstrumentsDepositsTransaction,
  FxForwardsPositions,
  FxForwardsTransactions,
  LoansPositions,
  LoansTransactions,
  VariousPositions,
  VariousTransactions,
  TransactionAdvice,
}
